<p><strong *ngIf="label">{{label|translate}}: </strong>{{text}} <i (click)="copy()" class='clickable bx bxs-copy' ></i></p>
